module.exports = __webpack_public_path__ + "assets/billing-address.9e623282.svg";